module.exports = __webpack_public_path__ + "img/wallet-3-line.34c78940.svg";